let adminServices = {
    "About": {
      id: "About",
      primary: 'About this Community',
      provider: 'Community',
      link:'',
      selected: true,
    },
    "Politics": {
      id: "Politics",
      primary: 'Politics',
      provider: 'Community',
      link:'',
      selected: false,
    },
    "Administration":{
      id: "Administration",
      primary: 'Administration',
      provider: 'Community',
      link:'',
      selected: true,
    },
    "Life": {
        id: "Life",
        primary: 'Life in the Community',
        provider: 'Community',
        link:'',
        selected: true,
      },
    "Economy": {
        id: "Economy",
        primary: 'Economy',
        provider: 'Community',
        link:'',
        selected: true,
      }, 
     "FreeTime": {
        id: "FreeTime",
        primary: 'FreeTime',
        provider: 'Community',
        link:'',
        selected: true,
      }, 
      "Culture":{
        id: "Culture",
        primary: 'Culture',
        provider: 'Community',
        link:'',
        selected: true,
      }, 
      "Services":{
        id: "Services",
        primary: 'Services',
        provider: 'Community',
        link:'',
        selected: true,
      }, 
    };

export default adminServices;